import { PropsWithChildren } from 'react';

import {
  NotificationsFormType,
  NotificationsFormSubmit,
  Form,
  getSchema,
  FormErrors,
} from '../../forms/notificationsForm';

export interface NotificationsSettingsFormProps {
  initialErrors?: FormErrors;
  onSubmit: NotificationsFormSubmit;
  initialValues?: Partial<NotificationsFormType>;
}

export const NotificationsSettingsForm = ({
  children,
  initialErrors,
  initialValues,
  onSubmit,
}: NotificationsSettingsFormProps & PropsWithChildren) => {
  const schema = getSchema();

  return (
    <Form
      initialErrors={initialErrors}
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      {children}
    </Form>
  );
};
